import { ReactElement, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function DefaultRedirect(): ReactElement | null {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/dashboard/default");
  }, [navigate]);

  return null;
}

export default DefaultRedirect;
